import { styled } from '@mui/material/styles';
import { Div } from '../../Atoms/Div';
import { Scheme } from '.';

export const HoverBlock = styled(Div)<{ scheme: Scheme }>`
  display: flex;
  cursor: pointer;
  &:hover {
    background: ${(props) => props.scheme?.linkHoverBackground};
  }
`;
